export enum CollectionVisibilityTypes {
    personal = "personal",
    public = "public",
}

export interface CollectionBaseData {
    displayName: string;
    description?: string;
    visibility: CollectionVisibilityTypes;
}

export interface CollectionEditData extends CollectionBaseData {
    id: string;
}

export enum SharingType {
    clipboard = "clipboard",
    email = "email",
    qrcode = "qrcode",
}

export interface CollectionDetailsData extends CollectionBaseData {
    id: string;
    entries: { entries: { cursor: string }[] };
    dashboard: boolean;
    totalCount: number;
    userId: string;
}
